/**
 * Prettier custom scrollbar
 */

import * as React from 'react';
import ScrollBars from 'react-custom-scrollbars';

/**
 * Themed scrollbar.
 * 
 * @param {React.Props<{}>} { children } 
 */
const CustomScrollBars = ({ children }: React.Props<{}>) => (
    <ScrollBars
        renderThumbVertical={props => <div {...props} className="Scrollbar-thumb-themed Theme-inverse"/>}
        renderThumbHorizontal={props => <div {...props} className="Scrollbar-thumb-themed Theme-inverse"/>}
    >
        {
            children
        }
    </ScrollBars>
);

export { CustomScrollBars };


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Stream/ScrollBar/CustomScrollBars.tsx